<button
  class="sidenav-item"
  [ngClass]="isSelected ? 'selected' : 'un-selected'"
  (click)="sidenavClicked()"
>
  <div class="d-flex justify-content-center">
    <i [ngClass]="[icon, 'iconText']"></i>
  </div>

  <div class="d-flex justify-content-center">
    <p class="itemText">{{ text }}</p>
  </div>

  @if (expand?.length) {
      <ng-container>
        <div class="expand-arrow d-flex justify-content-center">
          <i class="fa chevron" [ngClass]="isSelected ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>

        <div class="expand-container" [style.--count]="isSelected ? visibleItems.length : 0">

          @for (data of visibleItems; track data.id; let i = $index) {
            <button
              (click)="subSidenavClicked(data.id)"
              class="d-flex justify-content-center"
              [class.expand-item-active]="data.isSelected"
              [class.expand-item-passive]="!data.isSelected"
              [class.first-selected]="data.isSelected && i === 0"
              [attr.data-index]="i">
              <p class="expand-text">{{ data.subtitulo ?? data.text }}</p>
            </button>
          }

        </div>
      </ng-container>
  }
</button>
